import * as React from 'react';
import { connect } from 'react-redux';
import img404 from '../../assets/img/img404.gif';
import { Container, Row, Col } from 'reactstrap';
import { mergeStyles } from '@fluentui/react/lib/Styling';
import { FontIcon } from '@fluentui/react/lib/Icon';
import { colors } from '@material-ui/core';
const iconClass = mergeStyles({
  fontSize: 25,
  position: 'relative',
  top: "-100px",
  margin: 'auto',
  display: 'flex',


});
const hClass = mergeStyles({
  /* 
   height: 24,
   width: 24,
   margin: '-8px 5px',
   display: 'flex',
   float: 'right', */
  fontSize: 16,
  fontWeight: 600,
  marginTop: "23px",
  color: 'red'
});
const pStyle = mergeStyles({
  textAlign: "center",
  fontSize: 14,
  marginTop: "23px",
  width: "100%"
});

const NotFound404 = () => (

  <Container style={{ height: window.innerHeight - 500 }}>
    <div className="subheader">
      <h5>404 بروز خطا</h5>
    </div>
    <div className="comlayout">
      <Row>

        <Col  >

          <div style={{ position: "relative", zIndex: "5" }}>
            <p className={pStyle}>

              <h5 className={hClass}

              >

                کاربر گرامی، درخواست شما با خطا مواجه گشت


              </h5>

            </p>





            <p className={pStyle}>
              برای بازگشت به صفحه ی اصلی
              <a style={{ fontSize: "16px", color: "blue" }} href='/'><strong> اینجا </strong></a>
              کلیک نمایید.
            </p>


          </div>
        </Col>



      </Row>
      <Row>
        <Col>
          <div style={{ textAlign: 'center' }}>
            <img src={img404} alt="BigCo Inc. logo" className={iconClass} />

          </div>
        </Col>
      </Row>
    </div>
  </Container>
);

export default connect()(NotFound404);
